import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      id="prefix__Icons"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 32 32"
      xmlSpace="preserve"
      {...props}
    >
      <style>
        {
          '.prefix__st0{fill:none;stroke:#000;stroke-width:1;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}'
        }
      </style>
      <circle className="prefix__st0" cx={16} cy={16} r={14} />
      <circle className="prefix__st0" cx={16} cy={13} r={5} />
      <path className="prefix__st0" d="M5.4 25.1c1.8-4.1 5.8-7 10.6-7s8.9 2.9 10.6 7" />
    </svg>
  );
}

export default SvgComponent;
